import * as HttpService from "../../../../service/HttpService";

/** 用能管理  -> 对比分析服务 **/

/**
 * 获取曲线封装
 * @param type 类型 0: 日  1:月  2:年
 * @param params
 */
export const getCurves = (type, params) => {
    switch (type) {
        case "0": return getDayCurves(params.startDate, params.superiorId,params.ceResClass,params.ceResSortNo);
        case "1": return getMonthCurves(params.startDate, params.endDate, params.superiorId,params.ceResClass,params.ceResSortNo);
        case "2": return getYearCurves(params.startDate, params.endDate, params.superiorId,params.ceResClass,params.ceResSortNo);
        default: return getDayCurves(params.startDate, params.superiorId,params.ceResClass,params.ceResSortNo);
    }
}

/**
 * 获取日曲线
 * @param dateDay 日
 * @param superiorId 树节点id
 */
const getDayCurves = (day, superiorId,ceResClass,ceResSortNo) => {
    return HttpService.post(HttpService.DOMAIN + "/yongnengComparativeAnalysis/getYongnengComparativeAnalysisCurveDay?dateDay=" + day + "&superiorId=" + superiorId +"&ceResClass="+ceResClass+"&ceResSortNo="+ceResSortNo, {});
}

/**
 * 获取月曲线
 * @param startDay 开始日期
 * @param endDay 结束日期
 * @param superiorId 树节点id
 */
const getMonthCurves = (startDate, endDate, superiorId,ceResClass,ceResSortNo) => {
    return HttpService.post(HttpService.DOMAIN  + "/yongnengComparativeAnalysis/getYongnengComparativeAnalysisCurveMonth?startDate=" + startDate + "&endDate=" + endDate+ "&superiorId=" + superiorId+"&ceResClass="+ceResClass+"&ceResSortNo="+ceResSortNo, {});
}


/**
 * 获取年曲线
 * @param startMonth 开始月
 * @param endMonth 结束月
 * @param superiorId 树节点id
 */
const getYearCurves = (startDate, endDate, superiorId,ceResClass,ceResSortNo) => {
    return HttpService.post(HttpService.DOMAIN  + "/yongnengComparativeAnalysis/getYongnengComparativeAnalysisCurveYear?startDate=" + startDate + "&endDate=" + endDate+ "&superiorId=" + superiorId+"&ceResClass="+ceResClass+"&ceResSortNo="+ceResSortNo, {});
}

